import { doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { db } from '../../../../firebase';

export const markNotificationsRead = (userId: string, readThrough: Date) =>
  updateDoc(doc(db!, 'users', userId), {
    notificationsReadAt: readThrough,
  });

export const initializeNotificationsReadAt = (
  userId: string,
  previousActivity?: Date,
) => updateDoc(doc(db!, 'users', userId), {
  notificationsReadAt: previousActivity || serverTimestamp(),
});
